
//
// Box Selector
//
// Simple visual proxy for radio selection
//

module.exports = function BoxSelectorWidget ($host, config, $$) {

  // DOM

  var $inputs = $$('[data-box-key]');


  // State

  var callbacks = { change: [] };


  // Functions

  function isChecked (el) {
    return el.checked;
  }


  // Listeners

  $inputs.on('change', function () {
    var checkedInputs = $inputs.toArray().filter(isChecked);

    if (checkedInputs.length) {
      callbacks.change.map(invoke(checkedInputs[0].value, checkedInputs[0].dataset.boxKey));
    }
  });


  // Interface

  return {
    name:     $inputs[0].name,
    onChange: function (λ) { callbacks.change.push(λ); },
  }

}

